import { render, staticRenderFns } from "./select2empty.vue?vue&type=template&id=16f86cf2&lang=pug"
import script from "./select2empty.vue?vue&type=script&lang=js"
export * from "./select2empty.vue?vue&type=script&lang=js"
import style0 from "./select2empty.vue?vue&type=style&index=0&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports